module.exports = __webpack_public_path__ + "img/h-7.3f363e5f.png";